import React from 'react';
import styled from "styled-components";

function Header() {
  return (
      <HeaderDiv className="App">
        <HeaderText font_size="40px">
            Neural Vocoder Feature Estimation for Dry Singing Voice Separation
        </HeaderText>
        <HeaderText font_size="24px">
            Music and Audio Computing Lab, KAIST
        </HeaderText>
      </HeaderDiv>
  );
}

const HeaderDiv = styled.div`
width: 100%;
height: 240px;
background: #DCE2B4;

display: flex;
flex-direction: column;
justify-content: center;
align-items: center;
`

interface HeaderText {
    font_size: string;
 }
const HeaderText = styled("body")<HeaderText>`
font-family: 'Inter';
font-style: normal;
font-weight: 900;
font-size: ${(props) => props.font_size};
margin: 5px;

color: #614E43;
`

export default Header;